/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Discard_TitleInputs */

const en_us2_offline_discard_title = /** @type {(inputs: Offline_Discard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discard this entry?`)
};

const pt_br2_offline_discard_title = /** @type {(inputs: Offline_Discard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar este registro?`)
};

const es_419_offline_discard_title = /** @type {(inputs: Offline_Discard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Descartar este registro?`)
};

const pt_pt2_offline_discard_title = /** @type {(inputs: Offline_Discard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar este registo?`)
};

const fr_fr2_offline_discard_title = /** @type {(inputs: Offline_Discard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer cette entrée ?`)
};

const de_de2_offline_discard_title = /** @type {(inputs: Offline_Discard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesen Eintrag verwerfen?`)
};

const it_it2_offline_discard_title = /** @type {(inputs: Offline_Discard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scartare questa voce?`)
};

/**
* | output |
* | --- |
* | "Discard this entry?" |
*
* @param {Offline_Discard_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_discard_title = /** @type {((inputs?: Offline_Discard_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Discard_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_discard_title(inputs)
	if (locale === "es-419") return es_419_offline_discard_title(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_discard_title(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_discard_title(inputs)
	if (locale === "de-DE") return de_de2_offline_discard_title(inputs)
	if (locale === "it-IT") return it_it2_offline_discard_title(inputs)
	return en_us2_offline_discard_title(inputs)
});
export { offline_discard_title as "offline.discard_title" }